import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import mixpanelEvents from '@Mixpanel';
import { setAnswerFlags } from '@Actions/filterActions';
import { MultiSelectDropdown } from '@Components/UI/Dropdowns';
import { FilterDiv, InBodyTitle } from '../ScoreCardFilters.style';

const AnswersFilter = () => {
    const dispatch = useDispatch();

    const AnswersFlagsInput = useSelector(state => state.scoreCardFilters.AnswersFlagsInput);

    return (
        <FilterDiv>
            <InBodyTitle>Filter answers</InBodyTitle>
            <MultiSelectDropdown
                name="answers"
                options={AnswersFlagsInput}
                setOptions={input => {
                    dispatch(setAnswerFlags(input));
                    mixpanelEvents.scorecardFiltersApplied();
                }}
                answers
            />
        </FilterDiv>
    );
};

export default AnswersFilter;
